import { HttpParameterCodec, HttpParams } from "@angular/common/http";
import { Params } from "@angular/router";
import { IDisplayColumn } from '@shared/models/idb';
import { AppService } from '@core/services/app.service';

export const isArray = Array.isArray || ((arr) => arr && typeof arr.length === 'number');

export function isObject(o: any): boolean {
  return o != null && typeof o === 'object'
}

export function parseParams(params = {}): HttpParams {
  let httpParams = new HttpParams({ encoder: new UriEncoder() });
  serialize(params);
  return httpParams;

  function serialize(data: any, prefix = '', topLevel = true) {
    if (isObject(data)) {
      for (const key in data) {
        if (data[key] || data[key] == 0)
          serialize(data[key], prefix + (topLevel ? '' : '[') + key + (topLevel ? '' : ']'), false);
      }
    } else if (isArray(data)) {
      for (const key in data) {
        if (data[key] || data[key] == 0)
          serialize(data[key], prefix + '[' + (isObject(data[key]) ? key : '') + ']', false);
      }
    } else {
      httpParams = httpParams.append(prefix, (data == null ? '' : data));
    }
  }
}

export class UriEncoder implements HttpParameterCodec {
  encodeKey(key: string): string {
    return encodeURIComponent(key);
  }

  encodeValue(key: string): string {
    return encodeURIComponent(key);
  }

  decodeKey(key: string): string {
    return decodeURIComponent(key);
  }

  decodeValue(key: string) {
    return decodeURIComponent(key);
  }
}

export function castFloat(value: string | number | any): number {
  if (isNaN(value) || !value) {
    return 0;
  }
  return parseFloat(String(value));
}

export function castFloatFixed(value: string | number) {
  return parseFloat(String(value)).toFixed(2);
}

export function castInt(value: string | number | any): number {
  if (isNaN(value) || !value) {
    return 0;
  }
  return parseInt(String(value));
}

export function castString(value: string | number): string {
  return String(value);
}

export function castAutoNumber(value: string): number {
  value = value.replace(",", "");
  return parseFloat(String(value));
}


export function arraysAreEqual(arrA: any[], arrB: any[]) {
  if (!isArray(arrA) || !isArray(arrB)) {
    return false;
  }
  if (arrA.length !== arrB.length) {
    return false;
  }
  const allElementsInAExistInB = arrA.every(itemA => arrB.includes(itemA));
  const allElementsInBExistInA = arrB.every(itemB => arrA.includes(itemB));
  return allElementsInAExistInB && allElementsInBExistInA;
}

export function formatDecimal(n: any): any {
  n += '';
  if (!n.trim()) {
    return '';
  }

  const x = n.split('.');
  let x1 = x[0];
  const x2 = x.length > 1 ? ',' + x[1] : '';
  const rgx = /(\d+)(\d{3})/;
  while (rgx.test(x1)) {
    x1 = x1.replace(rgx, '$1' + '.' + '$2');
  }
  return x1 + x2;
}

/**
 *  Làm tròn số lớn => đổi sang dạng string
 *  VD: 2.000.000 => 2 triệu
 */
export function roundBigNumber(value: any, decimal?: any): string {

  decimal = decimal ? decimal : 2;
  const myInt = parseInt(value);

  let num = formatDecimal(myInt);
  let unit = '';
  if (myInt >= 900000) {
    num = decimalAdjust('round', myInt / 1000000, -1 * decimal).toString();
    unit = ' triệu';
  }
  if (myInt >= 900000000) {
    num = decimalAdjust('round', myInt / 1000000000, -1 * decimal).toString();
    unit = ' tỷ';

  }

  return num + '' + unit;
}

export function decimalAdjust(type: string, value: any, exp: number): number {

  // If the exp is undefined or zero...
  if (typeof exp === 'undefined' || +exp === 0) {
    // @ts-ignore
    return Math[type](value);
  }
  value = +value;
  exp = +exp;
  // If the value is not a number or the exp is not an integer...
  if (isNaN(value) || !(exp % 1 === 0)) {
    return NaN;
  }
  // If the value is negative...
  if (value < 0) {
    return -decimalAdjust(type, -value, exp);
  }
  // Shift
  value = value.toString().split('e');
  // @ts-ignore
  value = Math[type](+(value[0] + 'e' + (value[1] ? (+value[1] - exp) : -exp)));
  // Shift back
  value = value.toString().split('e');
  return +(value[0] + 'e' + (value[1] ? (+value[1] + exp) : exp));
}

export function findKeyByValue(object: any, value: any) {
  for (const key in object) {
    if (object[key] === value) {
      return key;
    }
  }
  return null;
}

export function isExitData(data: any) {
  if (isArray(data) && data.length) {
    return true
  } else if (isObject(data) && Object.keys(data).length) {
    return true
  } else if (data) {
    return true
  }
  return false
}


export function parseUrlFromParamsUri(baseUrl?: string, queryParams?: Params) {
  if (!baseUrl) {
    return '';
  }
  const searchParams = new URLSearchParams(queryParams ? queryParams : {});
  return `${baseUrl}?${searchParams.toString()}`;
}

interface URIParams {
  [key: string]: string | string[];
}

export function splitStringToUriParams(links: string): { uri: string, params: Params } {
  const split = links.split('?');
  const values: URIParams = {};

  if (split[1]) {
    const urlParams = new URLSearchParams(split[1].replace(/&amp;/g, '&'));
    urlParams.forEach((val, key) => {
      if (key in values) {
        // Kiểm tra xem giá trị hiện tại có phải là mảng không và thực hiện tương ứng
        if (isArray(values[key])) {
          (values[key] as string[]).push(val);
        } else {
          values[key] = [values[key] as string, val];
        }
      } else {
        values[key] = val;
      }
    });
  }
  return {
    uri: split[0] ?? '',
    params: values
  };
}

export function convertValueToArray(value: any) {
  if (!value && !isArray(value)) {
    return [];
  }
  if (value && !isArray(value)) {
    return [value]
  }
  return value
}

export function findIndexArray(arr: any[], value: any) {
  for (let i = 0; i < arr.length; i++) {
    if (arr[i] === value) {
      return i
    }
  }
  return -1
}

export function getMessages(messages: any) {
  if (isArray(messages)) {
    return messages.join('<br>');
  } else if (isObject(messages)) {
    return Object.entries(messages).map(([k, err]) => err).join('<br>');
  }

  return messages;
}

export function flattenUriConsts(obj: Record<any, any>): string[] {
  let result: string[] = [];
  for (const key in obj) {
    if (typeof obj[key] === 'object') {
      result = result.concat(flattenUriConsts(obj[key]));
    } else {
      result.push(obj[key]);
    }
  }
  return result;
}

/**
 * Hàm tính toán chia và làm tròn lên.
 *  + Hiện đang dùng nhiều ở tính huống tính số page dựa vào limit & totalItems
 *
 * @author admin
 * */
export function ceilDivision(dividend: number, divisor: number) {
  if (!dividend || !dividend) return 0;

  if (dividend < divisor) {
    return 1;
  }

  return Math.ceil(dividend / divisor);
}

export function translateColumnNames(columns: IDisplayColumn[], appService: AppService): string[] {
  if (!columns || !columns.length) {
    return [];
  }

  const headers: string[] = [];

  columns.forEach(cl => {
    let name = cl.nameOriginal ? cl.nameOriginal : '';
    if (cl.nameExcelCustom) {
      name = cl.nameExcelCustom;
    } else if (!name && cl.name) {
      name = appService.translate(cl.name);
    }
    cl.nameAfterTranslate = name;
    if (cl.display) {
      headers.push(name);
    }
  })

  return headers;
}

/**
 * Tạo danh sách pages cần chạy từ opts truyền vào
 *
 * @author admin
 * */
type IRangeOpts = {
  page: number,
  totalPages: number,
  totalItems: number,
}

export function createRangePage(opts: IRangeOpts) {
  let pageNumber = opts.page;
  const startPage = 1;
  const ranges: number[] = [];
  for (let x = startPage; x <= opts.totalPages; x++) {
    pageNumber = castInt(pageNumber) + 1;
    ranges.push(pageNumber);
  }
  return ranges
}
